import { TableHead, TableHeader, TableRow } from 'design-system';

import { LEGEND_COLUMNS } from './legend.constants';

const LegendTableHeader = () => (
  <TableHeader className='sticky top-0 z-10 bg-background'>
    <TableRow>
      {LEGEND_COLUMNS.map(column => (
        <TableHead
          key={column.key}
          className={column.key === 'value' ? 'text-right' : undefined}
        >
          {column.label}
        </TableHead>
      ))}
    </TableRow>
  </TableHeader>
);

export default LegendTableHeader;
